import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
import { useParams } from "react-router-dom";

function PmesHm({ title, data, header, itemsPerPage, modeleData }) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const api = Config.backOffice.apiName;
  let { id } = useParams();

  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);
  const style = { textAlign: "right" };

  return (
    <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
      {title?.can_add ? (
        <div>
          <Link to={`${backUrl}/pmes/`} className="btn btn-sm btn-primary">
            <i className="bx bx-plus"></i>Ajouter
          </Link>
        </div>
      ) : null}
      <table className="table">
        <thead>
          <tr>
            {title?.can_edit == false &&
            title?.can_show == false &&
            title?.can_destroy == false ? (
              <th></th>
            ) : (
              <th style={{ cursor: "default" }} key="Action" className="text">
                Action
              </th>
            )}
            {header.map((column, index) => (
              <th
                key={index}
                style={{
                  textWrap: "pretty",
                  paddingLeft: "8px",
                  textalign: "center",
                  verticalalign: "middle",
                  textAlign:
                    column === "RCS(siren)" || column === "Date de création"
                      ? "right"
                      : "left",
                }}
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ whiteSpace: "nowrap" }}>
          {paginatedData.length > 0 ? (
            <>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <ul className="list-unstyled hstack gap-1 mb-0">
                      {title?.can_show ? (
                        <li
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                        >
                          <Link
                            className="btn btn-sm btn-soft-primary"
                            id={`viewtooltip-${rowIndex}`}
                            to={`${backUrl}/pmes/${row.id}`}
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_edit ? (
                        <li title="Editer">
                          <Link
                            className="btn btn-sm btn-soft-info"
                            id={`edittooltip-${rowIndex}`}
                            to={`${backUrl}/pmes/${row.id}/edit`}
                          >
                            <i className="mdi mdi-pencil-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_destroy ? (
                        <li title="Supprimer">
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/pmes/${row.id}`}
                          />
                        </li>
                      ) : null}
                    </ul>
                  </td>

                  <td>{row?.societe}</td>
                  <td>{row?.statut}</td>
                  <td>{row?.produit}</td>
                  <td style={style}>{row?.rcs}</td>
                  <td style={style}>{row?.date_creation}</td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={header.length} style={{ textAlign: "center" }}>
                Aucune donnée à afficher
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"<<"}
        breakLabel={"..."}
        nextLabel={">>"}
        pageCount={Math.ceil(data.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageChange}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default PmesHm;
